export const BOOKING_STATUSES = [
  'scheduled',
  'completed',
  'business_to_approve', // consolidated status
  'pending_client_approval', // consolidated status
  'cancelled',
  'no_show', // For display only, this status does not exist in db
  'rejected',
  'request_expired',
  'done',
  'invited',
  'confirmed',
  'pending_reschedule',
  'proposed_time',
  'requested',
  'reschedule',
];

export const PAYMENT_STATUSES = [
  'not_paid',
  'paid'
]

export const EVENT_STATUSES = [
  'scheduled',
  'completed',
  'cancelled',
];

export const consolidateState = (state) => {
  switch (state) {
    case 'done':
      return 'completed';
    case 'confirmed':
      return 'scheduled';
    case 'reschedule':
    case 'requested':
      return 'business_to_approve';
    case 'invited':
    case 'proposed_time':
    case 'pending_reschedule':
      return 'pending_client_approval';
  }

  return state;
};

export const deconsolidateState = (state) => {
  switch (state) {
    case 'completed':
      return ['completed', 'done'];
    case 'scheduled':
      return ['scheduled', 'confirmed'];
    case 'business_to_approve':
      return ['reschedule', 'requested'];
    case 'pending_client_approval':
      return ['invited', 'proposed_time', 'pending_reschedule'];
  }

  return [state];
};
